export const MAGIC_CARD = 'magic-card';
export const METAL_BAND = 'metal-band';

export const LOCAL_STORAGE_KEY = 'bands';

export const SPACE_REPLACEMENT = '%20';
